/**
 * @file 拦截runtime，改造样式
 */
const runtime = require('react/jsx-runtime');
const { processorForNew } = require('../index');

const jsx_ = runtime.jsx;
const jsxs_ = runtime.jsxs;
const Fragment = runtime.Fragment;


function jsx (type, props, key) {
  let children = [];
  if (props.children) {
    if (Array.isArray(props.children)) {
      children = props.children;
    } else {
      children.push(props.children);
    }
  }

  return jsx_(type, processorForNew(props, ...children), key);
}

function jsxs (type, props, key) {
  let children = [];
  if (props.children) {
    if (Array.isArray(props.children)) {
      children = props.children;
    } else {
      children.push(props.children);
    }
  }

  return jsxs_(type, processorForNew(props, ...children), key);
}

module.exports = { Fragment, jsx, jsxs };